import { useContext } from 'react';
import { SettingsContext } from '@/contexts/SettingsContext';
import { invariant } from '@/utils/invariant';

export function useSettings() {
  return invariant(useContext(SettingsContext), 'useSettings must be used inside <SettingsProvider>.');
}
